import React, { useEffect, useRef } from "react";
import { Form, Input, Icon } from "antd";
import { useRouteMatch } from "react-router-dom";

import { CrossIcon } from "../../../../../resource/icons";
import AnswerCheckBox from "./answer-checkbox";
import {
	getAnswerFile,
	getAnswerFilePreview,
} from "../../../store/thunks/get-file";
import Attachment from "../../attachments/attachment";

const AnswerField = (props) => {
	const {
		form: { getFieldDecorator, getFieldValue, setFieldsValue },
		answerId,
		onDelete,
		questionId,
	} = props;
	const editing = !!useRouteMatch("/Voting/:id/editing");
	const ref = useRef();
	useEffect(() => {
		if (answerId >= 1 && !editing) {
			ref.current.input.focus();
		}
	}, [editing, answerId]);
	const uploadedFiles = [
		...(getFieldValue(`questions[${questionId}].answers[${answerId}].files`) ||
			[]),
	];
	const validateStatus =
		getFieldValue(`questions[${questionId}].answers[${answerId}].text`)
			?.length === 120
			? "warning"
			: "";
	return (
		<div className="answer">
			<div className="answer-options">
				<AnswerCheckBox {...props} />
				<Form.Item
					className="field"
					validateStatus={validateStatus}
					help={validateStatus ? "Достигнут лимит в 120 символов" : undefined}
				>
					{getFieldDecorator(
						`questions[${questionId}].answers[${answerId}].text`
					)(
						<Input
							maxLength={120}
							className="field-input"
							ref={ref}
							placeholder="Вариант ответа"
						/>
					)}
				</Form.Item>
				<label className="add-file">
					{getFieldDecorator(
						`questions[${questionId}].answers[${answerId}].files`,
						{
							getValueFromEvent: (e) => {
								return [...uploadedFiles, ...e.target.files];
							},
							valuePropName: "files",
						}
					)(<input type="file" className="input" multiple />)}
					<Icon type="file-add" style={{ fontSize: "20px" }} className="icon" />
				</label>
				{answerId > 0 && (
					<CrossIcon className="icon" onClick={() => onDelete(answerId)} />
				)}
			</div>
			{uploadedFiles && (
				<div className="attachments">
					{uploadedFiles.map((file, index) => {
						return (
							<Attachment
								key={index}
								uploadedFileText={file.name}
								onDelete={() =>
									setFieldsValue({
										[`questions[${questionId}].answers[${answerId}].files`]: [
											...uploadedFiles.filter(
												(attach) => attach.name !== file.name
											),
										],
									})
								}
								getFile={() => {
									return getAnswerFile(answerId, file.fileName);
								}}
								loadPreview={() =>
									getAnswerFilePreview(answerId, file.fileName)
								}
							/>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default AnswerField;
